export const MAX_SIGNER_COUNT = 30;
export const MAX_ATTACHMENT_REQUEST_COUNT = 30;
